<template>
  <div class="home-two">
    <div
      class="dragonfly"
      :style="{ backgroundImage: 'url(' + dragonfly + ')' }"
    ></div>
    <div class="page-content">
      <about-main />
      <professional-experience />
      <certifications />
      <education />
      <personal />
      <resume />
      <!-- <software /> -->
    </div>

    <div style="height: 150px;"></div>
    <!-- <CallToActions /> -->

  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import Header from "../../components/Header"
import Slider from "../../components/slider/SliderTwo"
import InventorySwiper from "../../components/swiper-inventory/SwiperInventory"
import About from "../../components/about/AboutTwo"
import Portfolio from "../../components/portfolio/PortfolioTwo"
import Skills from "../../components/skills/SkillsTwo"
import Video from "../../components/video/VideoTwo"
import Brand from "../../components/Brand"
import Testimonial from "../../components/testimonial/TestimonialTwo"
import News from "../../components/news/NewsTwo"
import CallToActions from "../../components/calltoactions/CallToActionsTwo"
import Footer from "../../components/Footer"
import MailPopup from "../../components/MailPopup"
import CookieLaw from 'vue-cookie-law'
import AboutMain from './AboutMain.vue'
import ProfessionalExperience from './ProfessionalExperience.vue'
import Software from './Software.vue'
import Education from './Education.vue'
import Certifications from './Certifications.vue'
import Personal from './Personal.vue'
import Resume from './Resume.vue'

export default {
  components: {
    Header,
    Slider,
    InventorySwiper,
    About,
    Portfolio,
    Skills,
    Video,
    Brand,
    Testimonial,
    News,
    CallToActions,
    Footer,
    CookieLaw,
    MailPopup,
    AboutMain,
    ProfessionalExperience,
    Software,
    Education,
    Personal,
    Resume,
    Certifications,
  },
  data() {
    return {
      constructionActive: false,
      dragonfly: require('../../assets/img/dragonfly.png')
    }
  },
  watch: {
    constructionActive(val) {
      if (val) {
        document.documentElement.style.overflow = 'hidden'
      } else {
        document.documentElement.style.overflow = 'auto'
      }
    },
  },
  computed: {
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped></style>

<style lang="css">

.dragonfly {
      width: 265px;
    height: 193px;
    position: absolute;
    z-index: -1;
    opacity: .07;
    top: 0;
    left: 0;
    transform: translate(-88px, -36px) rotate(135deg);
    background-size: contain;
    background-repeat: no-repeat;
}


.shane_tm_about {
  background: #f9f9f9 !important;
  margin-top: 130px !important;
  padding-top: 100px;
  padding-bottom: 70px;
}
.constructionImage {
  background: url("~@/assets/img/logo/logogray.png");
  opacity: .08;
  background-size: 150%;
  background-position-x: right;
  background-position-y: 20%;
}
.constructionHeader {
    position: absolute;
    left: 0;
    width: 100%;
    height: 100px;
    top: 0;
    background: white;
    z-index: 100;
    padding: 28px;
    padding-left: 40px;
    box-shadow: 0px 5px 20px 1px #00000033;
}
.veggies {
  position: absolute;
  width: 769px;
}

@media screen and (max-width: 600px) {
  .constructionLogo {
    display: none;
  }
  .constructionHeader .title {
    margin-top: 5px;
    font-size: 24px;
  }
  .underConstructionTitle {
    font-size: 18px;
  }
}
</style>